/**
 * Created by Administrator on 2017/10/30.
 */
import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {HttpService} from "../service/http-service";
import {API} from "../config/api-config";
import { DragulaService } from 'ng2-dragula/ng2-dragula';
declare var alertify:any;
@Component({
  templateUrl:'./category.html'
})

export class NewsCategory implements OnInit{

  constructor(
    private router:Router,
    private http:HttpService,
    private dragulaService: DragulaService
  ){
    dragulaService.drop.subscribe((value) => {
      //console.log('drop: ${value[0]}');
      this.onDrop(value.slice(1));
    });
  }

  private data:any=[];
  private imagePath:string='';

  private onDrop(args) {
  let [e, el] = args;
  // do something
  this.getList();
}

  private postData:any=[
  ];


  //推送
  public isLoading :boolean = false;
  private push(id:any):void{
    this.isLoading= true;
    this.http.postData(API.sendCategoryNotifyPushAll+"?"+'id'+'='+id,this.postData).then(res=>{
      let data=res;
      this.isLoading= false;
      if(data.status.code==0 || data.status.code=='0'){
        alertify.success(data.status.message);
      }else{
        alertify.error(data.status.message);
      }
    })
  }
  //成员推送
  private memberPush(id:any):void{
    this.isLoading= true;
    this.http.postData(API.sendCategoryNotifyPush+"?"+'id'+'='+id,this.postData).then(res=>{
      let data=res;
      this.isLoading= false;
      if(data.status.code==0 || data.status.code=='0'){
        alertify.success(data.status.message);
      }else{
        alertify.error(data.status.message);
      }
    })
  }




  //获取排序列表
  private getList(){
    this.postData = [];
    for(let i=1;i<this.data.length+1;i++){
      this.postData.push({'id':this.data[i-1].id,'rank':i});
    }
  }

  private sort():void{
    this.http.postData(API.newsCategory+"/sort",this.postData).then(res=>{
      let data=res;
      if(data.status.code==0 || data.status.code=='0'){
        alertify.success(data.status.message);
      }else{
        alertify.error(data.status.message);
      }
    })
  }

  private getPath():void{
    this.http.getData(API.resourcePath)
      .then(res=>{
        this.imagePath=res.data;
        this.getData();
      })
  }

  private getData(){
      this.http.getData(API.newsCategory).then(res=>{
        this.data = res.data;
        for (let i=0;i<this.data.length;i++){
          this.data[i].imgEn = this.imagePath+this.data[i].imgEn;
          this.data[i].imgTc = this.imagePath+this.data[i].imgTc;
          this.postData.push({'id':this.data[i].id,'rank':this.data[i].rank});
        }
      });
  }

  private editCategory(id:number):void{
    this.router.navigate(['index/news/category',id])
  }

  private deleteCategory(id:number):void{
    let _self = this;
    alertify.confirm("删除","確定要刪除嗎？",function () {
      _self.http.deleteData(API.newsCategory+"/"+id).then(res=>{
        if(res.status.code==0){
          alertify.success(res.status.message);
          _self.getData();
        }else {
          alertify.error(res.status.message);
        }
      })
    },function () {

    })
  }

  ngOnInit(): void {
    this.getPath();

  }



}




// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/news/Category.component.ts